import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAtom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="atom"><path d="M19.7074 4.29256C21.329 5.91416 19.1929 10.6795 14.9362 14.9362C10.6795 19.1929 5.91416 21.329 4.29256 19.7074C2.67096 18.0858 4.80713 13.3205 9.06383 9.06383C13.3205 4.80713 18.0858 2.67096 19.7074 4.29256Z" stroke="currentColor" strokeWidth="1.5"/><path d="M19.7074 19.7074C18.0858 21.329 13.3205 19.1929 9.06383 14.9362C4.80713 10.6795 2.67096 5.91416 4.29256 4.29256C5.91416 2.67096 10.6795 4.80713 14.9362 9.06383C19.1929 13.3205 21.329 18.0858 19.7074 19.7074Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAtom;
